// TransactionDocuments.section — section-config factory for the documents
// custom section.
//
// Split out of `TransactionDocuments.tsx` so that module only exports
// components (react-refresh/only-export-components).

import React from "react";
import type { TFunction } from "i18next";

import type { Transaction } from "@shared/types/transaction";

import { FILES_SUB_QUERY, TRANSPORTS_SUB_QUERY } from "../transactionConfig";
import { TransactionDocuments } from "./TransactionDocuments";

/** Section-config helper — call from `transactionConfig.tsx` `sections` array. */
export function transactionDocumentsSection(opts: {
  tabKey?: string;
  column?: "main" | "side" | "full";
  title?: (t: TFunction) => string;
}) {
  const title = opts.title ?? ((t: TFunction) => t("transactions.sections.documents", "Dokumenty"));
  return {
    kind: "custom" as const,
    key: "documents",
    column: opts.column ?? "main",
    tabKey: opts.tabKey,
    title,
    // Page-batch the `files` and `transports` sub-queries. `files` is read via
    // `useSubQueryOptional("files", id)` for the doc buckets. `transports` is
    // read via `useSubQueryOptional("transports", id)` so the generated bucket
    // knows the truck transport ID for the transport_order regenerate action.
    subQueries: [FILES_SUB_QUERY, TRANSPORTS_SUB_QUERY],
    render: (r: Transaction) => <TransactionDocuments record={r} />,
  };
}
